import React, { useEffect, useState } from 'react';
import { Banner } from '../ui/Banner';
import { isLocalStorageNearFull, getLocalStorageUsagePercent } from '../../utils/storageQuota';
/**
 * StorageWarningBanner — Surfaces localStorage quota warnings to users.
 *
 * Shows a dismissible warning banner when localStorage usage exceeds 80%.
 * Checks on mount and every 60 seconds thereafter.
 *
 * Addresses: RES-4 (storageQuota.ts not surfaced to users)
 */
export function StorageWarningBanner() {
  const [dismissed, setDismissed] = useState(false);
  const [usagePercent, setUsagePercent] = useState(0);
  const [isNearFull, setIsNearFull] = useState(false);
  useEffect(() => {
    function check() {
      setIsNearFull(isLocalStorageNearFull());
      setUsagePercent(getLocalStorageUsagePercent());
    }
    check();
    const interval = setInterval(check, 60000);
    return () => clearInterval(interval);
  }, []);
  if (!isNearFull || dismissed) return null;
  const isCritical = usagePercent > 95;
  return <Banner variant={isCritical ? 'danger' : 'warning'} onDismiss={() => setDismissed(true)} className="rounded-none sm:rounded-none border-x-0 border-t-0" data-id="element-2299">
      {isCritical ? 'Opslag bijna vol — gegevens kunnen verloren gaan. Neem contact op met je leerkracht of beheerder.' : `Opslag raakt vol (${usagePercent}% gebruikt). Overweeg oude gegevens op te ruimen.`}
    </Banner>;
}